import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { ActivityFilter as FilterValue } from "@/entities/activity";
import { Segmented, type SegmentedOption } from "@/shared/ui";

/**
 * Фильтры ленты. В отличие от `MarketFilter`, здесь есть явный пункт «Все»:
 * `filter` в контракте обязателен и по умолчанию равен `all`, то есть снятого
 * состояния у фильтра не существует.
 *
 * Фильтрует сервер, а не этот компонент: он только сообщает выбор наверх.
 */
const OPTIONS: readonly FilterValue[] = ["all", "results", "robots", "money"];

interface ActivityFilterProps {
  value: FilterValue;
  onChange: (value: FilterValue) => void;
}

export function ActivityFilter({ value, onChange }: ActivityFilterProps) {
  const { t } = useTranslation();

  const options = useMemo<readonly SegmentedOption<FilterValue>[]>(
    () => OPTIONS.map((option) => ({ value: option, label: t(`activity.filter.${option}`) })),
    [t],
  );

  return (
    <Segmented
      options={options}
      value={value}
      onChange={onChange}
      ariaLabel={t("activity.filterLabel")}
    />
  );
}
